var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m7 9 7-7M7.085 9.219l1.752 4.505c.154.397.231.595.342.653.097.05.212.05.308 0 .111-.057.189-.256.344-.652l4.393-11.259c.14-.358.21-.537.172-.651a.33.33 0 0 0-.21-.211c-.115-.038-.294.032-.652.171L2.274 6.17c-.397.155-.595.232-.653.343a.33.33 0 0 0 0 .308c.058.111.257.189.654.343L6.78 8.915c.08.031.12.047.155.071q.045.033.077.078c.025.034.04.074.072.155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "send_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSend;